/* eslint-disable react/jsx-no-useless-fragment */
import React, { FC } from "react";
import { Box, Button, TableCell } from "@mui/material";
import { ISelection } from "../helper";

interface Props {
  selection?: ISelection;
}

export const FixedCellValues: FC<Props> = ({ selection }) => (
  <>
    <TableCell align="center">
      <Box className="w-full flex align-center justify-center">
        <Box className="flex py-1 px-2 text-xs rounded-lg w-fit bg-surface-2">
          {selection?.status || "pending approval"}
        </Box>
      </Box>
    </TableCell>
    <TableCell align="center">{selection?.impressions || 0}</TableCell>
    <TableCell align="center">{selection?.plays || 0}</TableCell>
    <TableCell align="center">
      <>{((selection?.watch_time || 0) / 60).toFixed(1)} minutes</>
    </TableCell>
    <TableCell align="center">{selection?.likes || 0}</TableCell>
    <TableCell align="center">
      {selection?.status === "active" && (
        <>
          <Button
            size="small"
            onClick={() =>
              window.open(selection?.placement_url || "", "_target")
            }
          >
            View Placement
          </Button>
        </>
      )}
    </TableCell>
  </>
);
